import React from 'react';
import { CopyableField } from '../../copyable-field';

export const GetUpdatePaymentMethodLinkPane = ({
  updatePaymentMethodLink,
  title = 'Get update payment link',
  subTitle = 'Share the payment method link with the billing admin so they can add payment details',
}: {
  updatePaymentMethodLink: string;
  title?: string;
  subTitle?: string;
}) => {
  const [selectedField, setSelectedField] = React.useState<string>();
  return (
    <>
      <h2>{title}</h2>
      <h4>{subTitle}</h4>

      <CopyableField
        autoSelect={true}
        label={'Payment link with Jira markup e.g. [link title|http://example.com]'}
        value={`[Add a credit card to your account|${updatePaymentMethodLink}]`}
        buttonApperance="default"
        className={selectedField === 'textarea-1' ? 'copyable-button' : ''}
        onBtnClick={() => setSelectedField('textarea-1')}
        testId="copy-field-1"
      />
      <br />
      <CopyableField
        autoSelect={false}
        label={'Payment link'}
        value={updatePaymentMethodLink}
        buttonApperance="default"
        className={selectedField === 'textarea-2' ? 'copyable-button' : ''}
        onBtnClick={() => setSelectedField('textarea-2')}
        testId="copy-field-2"
      />
    </>
  );
};
